import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "reactstrap";
import "./Loading.css"; // Import your custom CSS file

const Loading = ({
  message = "Loading...",
  showSpinner = true,
  spinnerColor = "info",
  className = "",
}) => {
  return (
    <div
      className="d-flex justify-content-center align-items-center align-content-center"
      style={{ minHeight: "70vh" }}
    >
      <Spinner color={spinnerColor}>Loading...</Spinner>
    </div>
  );
};

Loading.propTypes = {
  message: PropTypes.string,
  showSpinner: PropTypes.bool,
  spinnerColor: PropTypes.string,
  className: PropTypes.string,
};

export default Loading;
